import { ResponsiveImage } from "@made-people/blueprint-responsive-image";
import { SizeGuideData, SizeGuideTab } from "./types";
import { useTranslate } from "@made-people/grease-translations";

interface SizeGuideTabsProps {
  sizeGuide: SizeGuideData;
  activeTab: SizeGuideTab;
  onTabChange: (tab: SizeGuideTab) => void;
}

export const SizeGuideTabs = ({
  sizeGuide,
  activeTab,
  onTabChange,
}: SizeGuideTabsProps) => {
  const translate = useTranslate();
  const handleTabClick = (tab: SizeGuideTab) => {
    onTabChange(tab);
  };

  const handleKeyDown = (e: React.KeyboardEvent, tab: SizeGuideTab) => {
    if (e.key === "Enter") {
      onTabChange(tab);
    }
  };

  const tabs = [
    {
      id: "bra" as const,
      label: translate("Size_Guide_Bra"),
      icon: sizeGuide.brasIcon,
    },
    {
      id: "panty" as const,
      label: translate("Size_Guide_Panties"),
      icon: sizeGuide.pantiesIcon,
    },
    {
      id: "swimwear" as const,
      label: translate("Size_Guide_Swimwear"),
      icon: sizeGuide.swimIcon,
    },
    {
      id: "stockings" as const,
      label: translate("Size_Guide_Stockings"),
      icon: sizeGuide.stockingsIcon,
    },
    {
      id: "camisoles" as const,
      label: translate("Size_Guide_Top"),
      icon: sizeGuide.camisolesIcon,
    },
  ];

  return (
    <div className="gap-3 lg:gap-6 mb-8 grid-cols-3 overflow-scroll w-full grid lg:flex">
      {tabs.map(({ id, label, icon }) => (
        <button
          key={id}
          className={`flex flex-col items-center border rounded-lg lg:min-w-[130px] p-2 lg:p-4 w-full ${
            activeTab === id ? "border-[#383838]" : "border-[#c5bfb0]"
          }`}
          onClick={() => handleTabClick(id)}
          onKeyDown={(e) => handleKeyDown(e, id)}
          tabIndex={0}
          aria-label={`${label} ${translate("Size_Guide_Title")}`}
        >
          {icon?.filename && (
            <div className="h-[90px] w-full flex items-center justify-center mb-3">
              <ResponsiveImage
                initial={{
                  src: icon.filename,
                  alt: icon.alt || `${label} Icon`,
                }}
                displaySize="140px"
                className="h-full max-w-full object-contain w-full"
              />
            </div>
          )}
          <div>{label}</div>
        </button>
      ))}
    </div>
  );
};
